export const COPY_URL_CATEGORY_KEY = 'base' as const;
export const COPY_URL_COMPONENT_KEY = 'CopyButton' as const;
